import { SkeletonLight } from '@/components/skeleton/skeleton.light';
import { type AvatarProps } from '../-model/props';
import { cn, ImageProfile, mage, useInMediaQuery } from '@nosinovacao/nosid-mfe-common';
import { Link } from '@tanstack/react-router';
import { AvatarPictureLight } from '../../-components/avatar-picture.light';

export function AvatarsLight({
  isLoading,
  list,
  sa,
  kids,
  links,
  profileId,
  hasPin,
  validationState,
}: Readonly<AvatarProps>) {
  const isTablet = useInMediaQuery('tablet');
  const isXlDesktop = useInMediaQuery('desktop-xl');
  const avatarSize = isXlDesktop ? 108 : isTablet ? 96 : 128;
  const avatarGridTemplate = `repeat(auto-fit, minmax(min(100%, ${avatarSize}px), 1fr))`;

  return (
    <div
      className={cn(
        'overflow-y-auto overflow-x-clip max-tablet:pb-8',
        isLoading && 'grid size-full h-fit place-items-center gap-x-6 gap-y-8',
      )}
      style={isLoading ? { gridTemplateColumns: avatarGridTemplate } : undefined}
    >
      <SkeletonLight
        loading={isLoading}
        count={10}
        className="size-32 rounded-full tablet:size-24 desktop-xl:size-28"
      >
        <div
          className="grid size-full place-items-center gap-x-6 gap-y-8"
          style={{ gridTemplateColumns: avatarGridTemplate }}
        >
          {list.map((avatar) => {
            const picture = (
              <AvatarPictureLight
                name={undefined}
                size={avatarSize}
                src={mage.getImage(avatar.ImageUri, ImageProfile.Avatar)}
              />
            );
            return profileId ? (
              <Link
                data-tid="link-avatar"
                key={avatar.Id}
                to="/tv/$id/profiles/$profileId/update"
                params={{ id: sa, profileId }}
                search={{ kids, hasPin }}
                state={validationState as never}
                hash={links[avatar.Id]}
              >
                {picture}
              </Link>
            ) : (
              <Link
                data-tid="link-avatar"
                key={avatar.Id}
                to="/tv/$id/profiles/create"
                params={{ id: sa }}
                search={{ kids }}
                hash={links[avatar.Id]}
              >
                {picture}
              </Link>
            );
          })}
        </div>
      </SkeletonLight>
    </div>
  );
}
